import axios, { type AxiosError, type AxiosRequestConfig, type InternalAxiosRequestConfig } from "axios";
import store from "../store";
import { setSnackAction } from "../store/slices/snackSlice";

// `errorHandle: false` on a per-request config opts that call out of the global
// snack-on-error behaviour, leaving the caller to surface the error itself.
interface RequestConfigWithErrorHandle extends AxiosRequestConfig {
    errorHandle?: boolean;
}

function errorResponseHandler(error: AxiosError): Promise<never> {
    console.log(JSON.stringify(error));

    const config = error.config as InternalAxiosRequestConfig & RequestConfigWithErrorHandle | undefined;
    if (config?.errorHandle === false) {
        return Promise.reject(error);
    }

    if (error.response) {
        console.log(error.response);
        if (error.response.status === 401) {
            store.dispatch(setSnackAction(`Access Denied`, "error"));
            return Promise.reject(error);
        }
        if (error.response.status === 422) {
            store.dispatch(setSnackAction(error.response.data as string, "error"));
            return Promise.reject(error);
        }

        const data = error.response.data as { title?: string } | undefined;
        store.dispatch(setSnackAction(data?.title ?? "Request failed", "error"));
        return Promise.reject(error);
    } else if (error.request) {
        store.dispatch(setSnackAction("No response from server", "error"));
        return Promise.reject(error);
    } else {
        store.dispatch(
            setSnackAction(error.message || "Something went wrong.", "error"),
        );
        return Promise.reject(error);
    }
}

const instance = axios.create({});

instance.interceptors.response.use((response) => response, errorResponseHandler);

export const setAuthHeader = (accessToken: string): void => {
    instance.defaults.headers.common["Authorization"] = "Bearer " + accessToken;
    instance.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";
};

export default instance;
